import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEmail1"><Path d="M2.18439 4L12 12.031L21.8156 4H2.18439Z" fill="currentColor"/><Path d="M2 5.78723V20H22V5.78723L12 13.969L2 5.78723Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail1;
